import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { BlockMobile as Block } from '@alfa-bank/site-block/mobile';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';
import { DataLayer } from '@alfa-bank/site-data-layer/';

import type { IDependencies, TCard } from '../models';
import { PROMO_CARD_MOBILE_HEIGHT, PROMO_CARD_MOBILE_WIDTH } from '../config';
import { PromoCardV2 as Component } from '../promo-card-v2';

import styles from './mobile.css';

export const PromoCardMobileV2 = createWidget<IDependencies, TCard>({
    Block,
    useNamedContainers,
    styles,
    defaultWidth: PROMO_CARD_MOBILE_WIDTH,
    defaultHeight: PROMO_CARD_MOBILE_HEIGHT,
    DataLayer,
    config: {
        padding: 16,
        borderRadius: 24,
        margin: {
            marginBottom: 0,
            marginTop: 0,
            marginLeft: 0,
            marginRight: 0,
        },
    },
})(Component);
